import React from 'react'
import Link from 'next/link'

import Breadcrumbs from '@/components/hero/Breadcrumbs'
import { decodeSafeEntities } from '@/lib/sanitise-strings'

export type HeroTextSlotProps = {
  heroStyle: 'basic' | 'text-and-asset' | 'branded' | 'single'

  breadcrumbs?: any

  title: string
  titleTag?: string
  titleClass?: string
  titleLink?: string
  text?: string

  subDetails?: React.ReactNode | null
}

export default function HeroTextSlot({
  heroStyle = 'basic',
  breadcrumbs,
  title,
  titleLink,
  titleTag = 'h1',
  titleClass = 'h1',
  text,
  subDetails = null,
}: HeroTextSlotProps) {
  if (!title) {
    return null
  }

  return (
    <>
      <div className="flex w-full flex-col items-start gap-m">
        {/* Breadcrumb, title and text */}
        <div className="flex flex-col items-start gap-m">
          <div className="flex flex-col items-start gap-xxs">
            <Breadcrumbs breadcrumbs={breadcrumbs} />

            {titleLink ? (
              <Link href={titleLink} className="hover:text-primary">
                {React.createElement(
                  titleTag,
                  {
                    className: `hover:text-primary ${titleClass} ${heroStyle !== 'basic' && heroStyle !== 'single' ? 'h1--large' : ''}`,
                  },
                  decodeSafeEntities(title),
                )}
              </Link>
            ) : (
              React.createElement(
                titleTag,
                {
                  className: `${titleClass} ${heroStyle !== 'basic' && heroStyle !== 'single' ? 'h1--large' : ''}`,
                },
                decodeSafeEntities(title),
              )
            )}
          </div>

          {text ? (
            <div
              className="p--large mb-0 text-fg-subtitle"
              dangerouslySetInnerHTML={{ __html: text ? text : '' }}></div>
          ) : null}
        </div>

        {subDetails ? subDetails : null}
      </div>
    </>
  )
}
